module.exports = __webpack_public_path__ + "img/selected5-min.ad755c31.png";